<!-- Button -->
<button
	mat-icon-button
	[matMenuTriggerFor]="userActions"
	[matTooltip]="hubStatusTooltip()"
>
	<span class="relative">
		@if (showAvatar() && user.avatar) {
		<img class="w-7 h-7 rounded-full" [src]="user.avatar" />
		} @if (!showAvatar() || !user.avatar) {
		<mat-icon
			class="icon-size-6"
			[svgIcon]="'heroicons_outline:user-circle'"
		></mat-icon>
		}
		<span
			class="absolute right-0 bottom-0 w-2 h-2 rounded-full pointer-events-auto"
			[ngClass]="{
				'mr-px mb-px': !showAvatar() || !user.avatar,
				'bg-green-500': hubStatus() === 'connected',
				'bg-amber-500': hubStatus() === 'connecting',
				'bg-red-500': hubStatus() === 'disconnected',
			}"
		></span>
	</span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
	<button mat-menu-item>
		<span class="flex flex-col leading-none">
			<span>Signed in as</span>
			<span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
		</span>
	</button>
	<mat-divider class="my-2"></mat-divider>
	<button mat-menu-item [routerLink]="['profile']">
		@if (showAvatar() && user.avatar) {
		<img class="w-6 h-6 rounded-full mr-3" [src]="user.avatar" />
		} @if (!showAvatar() || !user.avatar) {
		<mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
		}
		<span>Profile</span>
	</button>
	<button mat-menu-item (click)="openWhatsNew()">
		<mat-icon [svgIcon]="'heroicons_outline:bell-alert'"></mat-icon>
		<span>What's New</span>
	</button>
	@if (pwaAccess.canInstall()) {
	<button mat-menu-item (click)="installApp()">
		<mat-icon>install_mobile</mat-icon>
		<span>Install App</span>
	</button>
	}
	@if(false) {
	<button mat-menu-item (click)="startTour()">
		<mat-icon svgIcon="heroicons_outline:book-open"></mat-icon>
		<span>Start Tour</span>
	</button>
	}
	<mat-divider class="my-2"></mat-divider>
	<button mat-menu-item (click)="signOut()">
		<mat-icon
			[svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
		></mat-icon>
		<span>Sign out</span>
	</button>
</mat-menu>
